import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import ROUTES from "./RoutesConstants";
import { getisAuthenticated, getUserRole } from "./modules/reducers";
import Login from "./screens/Login";
import { ROLE_REDIRECT_MAP } from "./constants";

function isUserAuthorized(path, userRole) {
  const route = ROUTES.find((r) => {
    // Replace dynamic segments like :bid with a regex pattern to match alphanumeric values
    const routeRegex = new RegExp(`^${r.path.replace(/:\w+/g, "[^/]+")}$`);
    return routeRegex.test(path); // Check if the path matches the route
  });
  if (!route) return false; // No route matches
  return route.roles.includes(userRole); // Check if user's role is allowed
}

function getRedirectPath(userRole) {
  return ROLE_REDIRECT_MAP[userRole] || ROLE_REDIRECT_MAP.default;
}

const App = ({ isAuthenticated, userRole }) => {
  return (
    <BrowserRouter basename="/adminPortalNew/">
      <Switch>
        <Route path="/" component={Login} exact />

        {isAuthenticated ? (
          ROUTES.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              exact
              render={(props) =>
                isUserAuthorized(route.path, userRole) ? (
                  React.createElement(route.component, props)
                ) : (
                  <Redirect to={getRedirectPath(userRole)} />
                )
              }
            />
          ))
        ) : (
          <Redirect to="/" />
        )}
      </Switch>
    </BrowserRouter>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: getisAuthenticated(state),
  userRole: getUserRole(state),
});

export default connect(mapStateToProps)(App);
